import envConfig from '../../../config';
import CoreAPIService from '../../../utils/core-api';
import { fetchAction } from '../../actions';
import { errorTypes, pendingTypes } from '../../types';

export const name: string = 'ridesImport';

export const types = {
    IMPORT_RIDE: name + '/IMPORT_RIDE',
    GET_PRICE_ESTIMATE: name + '/GET_PRICE_ESTIMATE',
    CLEAR_PRICE_ESTIMATE: name + '/CLEAR_PRICE_ESTIMATE',
};

export interface PriceEstimate {
    amount_ht: number;
    status: 'loading' | 'resolved' | 'error';
}

interface RidesImportState {
    submitting: boolean;
    submitError: string | null;
    submitResult: unknown | null;
    estimate: PriceEstimate | null;
}

const initialState: RidesImportState = {
    submitting: false,
    submitError: null,
    submitResult: null,
    estimate: null,
};

const reducer = (state = initialState, action): RidesImportState => {
    switch (action.type) {
        case pendingTypes.START_PENDING_OPERATION:
            if (action.payload?.type === types.IMPORT_RIDE) {
                // Drop the previous success banner so a failed retry does not read as a success
                return { ...state, submitting: true, submitResult: null };
            }
            if (action.payload?.type === types.GET_PRICE_ESTIMATE) {
                return { ...state, estimate: { amount_ht: 0, status: 'loading' } };
            }
            return state;
        case errorTypes.DISPATCH_ERROR:
            if (action.payload?.errorType === types.IMPORT_RIDE) {
                return { ...state, submitting: false };
            }
            if (action.payload?.errorType === types.GET_PRICE_ESTIMATE) {
                return { ...state, estimate: { amount_ht: 0, status: 'error' } };
            }
            return state;
        case types.IMPORT_RIDE:
            return { ...state, submitting: false, submitError: null, submitResult: action.payload };
        case types.GET_PRICE_ESTIMATE:
            return { ...state, estimate: { amount_ht: action.payload?.data?.price ?? 0, status: 'resolved' } };
        case types.CLEAR_PRICE_ESTIMATE:
            return { ...state, estimate: null };
        default:
            return state;
    }
};
export default reducer;

export const actions = {
    importRide: (payload: unknown) =>
        fetchAction(CoreAPIService.post('rides/import', payload, null, envConfig.privapi_url), types.IMPORT_RIDE, {}),
    getPriceEstimate: (params: {
        company_id: string;
        service_id?: string;
        start_location: { lat: number; lng: number };
        end_location: { lat: number; lng: number };
        date?: number;
    }) => fetchAction(CoreAPIService.post('pricing/price/calculate', params, null, null), types.GET_PRICE_ESTIMATE, {}),
    clearPriceEstimate: () => ({ type: types.CLEAR_PRICE_ESTIMATE }),
};

const localState = (state: any): RidesImportState => state[name] || initialState;
export const selectors = {
    submitting: (state) => localState(state).submitting,
    submitError: (state) => localState(state).submitError,
    submitResult: (state) => localState(state).submitResult,
    estimate: (state) => localState(state).estimate,
};
